import { render, staticRenderFns } from "./approval-cancel.vue?vue&type=template&id=15bf3dc3&scoped=true"
import script from "./approval-cancel.vue?vue&type=script&lang=js"
export * from "./approval-cancel.vue?vue&type=script&lang=js"
import style0 from "./approval-cancel.vue?vue&type=style&index=0&id=15bf3dc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bf3dc3",
  null
  
)

export default component.exports